// LoginForm.jsx
import { LoginContainer } from './components/LoginContainer';
import { LoginCard } from './components/LoginCard';
import { LoginImage } from './components/LoginImage';
import { LoginFormContent } from './components/LoginFormContent';
import { LoginFormFields } from './components/LoginFormFields';
import { useLoginForm } from './hooks/useLoginForm';

const LoginForm = () => {
  const hookData = useLoginForm();

  return (
    <LoginContainer>
      <LoginCard>
        <LoginImage src={hookData.images.loginBackground} />
        <LoginFormContent {...hookData}>
          <LoginFormFields {...hookData} />
        </LoginFormContent>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginForm;
